import { Inject, Injectable, Optional } from '@angular/core';

import { zxcvbn, zxcvbnOptions } from '@zxcvbn-ts/core';
import { PSMOptions, PSM_CONFIG } from '../components/password-strength-meter/password-strength-meter.types';

import * as zxcvbnEnPackage from '@zxcvbn-ts/language-en';

export const DEFAULT_CONFIG: PSMOptions = {
  translations: zxcvbnEnPackage.translations,
};

@Injectable({
  providedIn: 'root'
})
export class PasswordStrengthMeterService {
  constructor(
    @Optional()
    @Inject(PSM_CONFIG)
    options: PSMOptions
  ) {
    if (options) {
      zxcvbnOptions.setOptions(options);
    } else {
      zxcvbnOptions.setOptions(DEFAULT_CONFIG);
    }
  }

  /**
   *  this will return the password strength score in number
   *  0 - too guessable
   *  1 - very guessable
   *  2 - somewhat guessable
   *  3 - safely unguessable
   *  4 - very unguessable
   *
   *  @param password - Password
   */
  score(password): number {
    const result = zxcvbn(password);
    return result.score;
  }

  /**
   * this will return the password strength score with feedback messages
   * return type { score: number; feedback: { suggestions: string[]; warning: string } }
   *
   * @param password - Password
   */
  scoreWithFeedback(password): {
    score: number;
    feedback: { suggestions: string[]; warning: string };
  } {
    const result = zxcvbn(password);
    return { score: result.score, feedback: result.feedback };
  }
}
